module.exports = __webpack_public_path__ + "static/mahmoud-3eccb66c463325c54d97dda965f249cf.jpg";